export function disableScroll() {
	if (import.meta.client) {
		document.body.style.overflowY = 'hidden';
	}
}

export function enableScroll() {
	if (import.meta.client) {
		document.body.style.overflowY = 'auto';
	}
}
